import React from 'react'
import { Button } from 'sputnik-ui'
import { connect } from 'react-redux'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'

import Zoom from '@material-ui/core/Zoom'
import { cancelReservation } from 'store/resources/operations'

function Transition(props) {
  return <Zoom direction="up" {...props} />
}

function CancelReservationsModal({ house, reservation, dispatch, open, handleClose }) {
  const handleCancel = () => {
    dispatch(cancelReservation(house.uuid)).then(handleClose).catch(handleClose)
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
      PaperProps={{ style: { minWidth: 350 } }}
    >
      <DialogTitle>Снять бронирование с адреса?</DialogTitle>
      <DialogContent>Это действие невозможно будет отменить</DialogContent>
      <DialogActions>
        <Button onClick={handleClose} rounded secondary disabled={reservation.loading}>
          отмена
        </Button>
        <Button onClick={handleCancel} disabled={reservation.loading} rounded primary>
          Подтвердить
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = ({ resources: { current, reservation } }) => ({
  house: current,
  reservation: reservation,
})

export default connect(mapStateToProps)(CancelReservationsModal)
